<div class="service-type-title margin-top-8 p-inputgroup" *ngIf="isPortal">
    <input type="text" pInputText placeholder="{{ 'general.search' | translate }}"
           (input)="search($event.target['value'] )"/>
    <!--  todo(dcorbett) removed $event.target.value-->
    <span class="p-inputgroup-addon" (click)="addCategory()"><i class="fa hubtiger-search"></i></span>
</div>

<div class="service-type-title margin-top-8 p-inputgroup" *ngIf="!isCollections">
    <input type="text" pInputText placeholder="Add a category" [(ngModel)]="category"
           (keyup)="$event.keyCode === 13 ? addCategory() : null"/>
    <span class="p-inputgroup-addon" (click)="addCategory()" [ngClass]="{disabled: category.length === 0}"><i
            class="fa fa-plus-circle add-icon-category"></i></span>
</div>
<div class="service-type-container margin-top-8">
    <div *ngIf="loading" class="margin-top-8">
        <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s"></p-progressSpinner>
    </div>
    <div *ngFor="let category of Categories; let i = index" style="width: 100%;">
        <div class="service-type-category mb-1">
            <div class="category-container" (click)="setOpen(category.name)">
                <div style="display: flex; align-items: center;">
                    <button class="hamburger hamburger--slider" [ngClass]="{
              'is-active': open === category.name || open === 'all'
            }" type="button">
            <span class="hamburger-box">
              <span class="hamburger-inner"></span>
            </span>
                    </button>
                    <input *ngIf="editCategory === i"
                           style="width: auto;margin-right: 16px;margin-top: 4px;margin-bottom: 4px;"
                           type="text" pInputText [(ngModel)]="category.name"
                           autofocus (blur)="changeCategoryName(i)" (keyup.enter)="changeCategoryName(i)"/>
                    <h5 *ngIf="!(editCategory === i)">
                        {{ category.name || "Other" }}
                    </h5>
                </div>
            </div>
            <span>
        <div id="wave" (click)="setOption(category.name)">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
        <div class="option-box" [ngClass]="{ hide: option !== category.name }">
          <div class="option" (click)="addServiceType(category.name)">
            Add New Service
          </div>
          <div class="option" *ngIf="!isCollections" (click)="setEditCategory(i)">
            Edit Category
          </div>
          <div class="option caution" *ngIf="category.deletable && !isCollections"
               (click)="deleteCategory(category.name)">
            Delete Category
          </div>
        </div>
      </span>
        </div>
        <div *ngIf="open === category.name || open === 'all'" class="service-type-item">
            <div *ngFor="let serviceType of serviceTypes[category.name]" [routerLink]="['/store/service-types-edit']"
                 (click)="editServiceType(serviceType)"
                 class="clear-box">
        <span class="service-type-name" style="flex: 1;">
          {{ serviceType.ServiceTypeDescription }}
        </span>
                <span class="service-type-time" style="flex: 0.5;">
          <span>{{ serviceType.displayTime }}</span>
        </span>
                <span class="service-type-name" style="flex: 0.5;">
          <span style="float: right;">{{ currencySymbol }} {{ serviceType.Cost }}</span>
        </span>
            </div>
        </div>
    </div>
</div>

<div class="service-type-container margin-top-8"></div>

<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
